<template>
  <v-container :dark="$store.getters.getColorPalette().isDark" fluid>
    <InfoAlert
      :showDismissibleAlert="showDismissibleAlert"
      v-on:close="showDismissibleAlert = false"
      :info="info"
    />
    <v-form
      :dark="$store.getters.getColorPalette().isDark"
      ref="widgetForm"
      v-model="widgetValid"
    >
      <v-card
        :dark="$store.getters.getColorPalette().isDark"
        :style="{
          border:
            '1px solid ' +
            $store.getters.getColorPalette().panelBorderColorCode,
          'background-color':
            $store.getters.getColorPalette().background2ColorCode,
        }"
        flat
        outlined
        class="pa-3"
      >
        <v-card-title v-if="edit" class="sub-heading"
          >{{ $store.getters.getTextMap().edit }}
          {{
            $store.getters.getTextMap()
              .manufacturing_logbook_kpi_bartrend_widget
          }}</v-card-title
        >
        <v-card-title v-else class="sub-heading"
          >{{ $store.getters.getTextMap().add }}
          {{
            $store.getters.getTextMap()
              .manufacturing_logbook_kpi_bartrend_widget
          }}</v-card-title
        >
        <v-row>
          <!--   Label -->
          <v-col>
            <v-skeleton-loader v-if="loading"></v-skeleton-loader>
            <v-text-field
              dense
              outlined
              v-model="widgetForm.label"
              :counter="30"
              :rules="[rules.required]"
              :label="$store.getters.getTextMap().widget_label"
            >
            </v-text-field>
          </v-col>
          <!-- widget width -->
          <v-col>
            <v-select
              dense
              outlined
              :dark="$store.getters.getColorPalette().isDark"
              :color="$store.getters.getColorPalette().inputTextColor"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
              v-model="widgetForm.width"
              :items="widthOptions"
              :label="$store.getters.getTextMap().widget_width"
              item-text="label"
              item-value="value"
              :rules="[rules.required]"
            >
            </v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col align-self="center">
            <v-select
              v-model="widgetForm.background_color"
              :items="$store.getters.getBackgroundColorOptions()"
              :label="$store.getters.getTextMap().background_color"
              dense
              outlined
              item-text="label"
              item-value="value"
              clearable
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
            >
              <template v-slot:selection="{ item }">
                <div :style="{ 'background-color': item.value }">
                  {{ item.label }}
                </div>
              </template>
              <template v-slot:item="{ item }">
                <div :style="{ 'background-color': item.value }">
                  {{ item.label }}
                </div>
              </template>
            </v-select>
          </v-col>
          <!-- widget swq -->
          <v-col align-self="center">
            <v-text-field
              v-model="widgetForm.seq"
              :counter="3"
              :label="$store.getters.getTextMap().sequence"
              dense
              outlined
            ></v-text-field>
          </v-col>
          <!-- widget height -->
          <v-col>
            <v-select
              :dark="$store.getters.getColorPalette().isDark"
              :color="$store.getters.getColorPalette().inputTextColor"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
              v-model="widgetForm.height"
              :items="heightOptions"
              item-text="label"
              item-value="value"
              :label="$store.getters.getTextMap().widget_height"
              :rules="[rules.required]"
              dense
              outlined
            >
            </v-select>
          </v-col>
          <!-- TImeframe Option -->
        </v-row>
        <v-row>
          <v-col v-if="!disableTimeframe" align-self="center">
            <v-select
              :dark="$store.getters.getColorPalette().isDark"
              :color="$store.getters.getColorPalette().inputtextColor"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
              v-model="widgetForm.meta.timeFrame"
              :items="tdOptions"
              :label="$store.getters.getTextMap().timeFrame"
              dense
              outlined
              item-text="label"
              item-value="value"
            ></v-select>
          </v-col>
          <!--default Graph mode  -->
          <v-col align-self="center">
            <v-select
              :dark="$store.getters.getColorPalette().isDark"
              :color="$store.getters.getColorPalette().inputtextColor"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
              v-model="widgetForm.meta.graph_type"
              :items="graphTypeOptions"
              :label="$store.getters.getTextMap().default_graph_type"
              dense
              outlined
              item-text="label"
              item-value="value"
            ></v-select>
          </v-col>
          <v-col align-self="center">
            <v-select
              :dark="$store.getters.getColorPalette().isDark"
              :color="$store.getters.getColorPalette().inputtextColor"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
              v-model="widgetForm.meta.aggregation"
              :items="aggregationOptions"
              :label="$store.getters.getTextMap().aggregation"
              dense
              outlined
              item-text="label"
              item-value="value"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              :dark="$store.getters.getColorPalette().isDark"
              :color="$store.getters.getColorPalette().inputtextColor"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
              v-if="!loading"
              v-model="widgetForm.meta.yaxisLabel"
              :label="$store.getters.getTextMap().yaxis_label"
              dense
              outlined
              item-text="label"
              item-value="value"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              :dark="$store.getters.getColorPalette().isDark"
              :color="$store.getters.getColorPalette().inputtextColor"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
              v-if="!loading"
              v-model="widgetForm.meta.xaxisLabel"
              :label="$store.getters.getTextMap().xaxis_label"
              dense
              outlined
              item-text="label"
              item-value="value"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col align-self="center">
            <v-skeleton-loader
              v-if="loading"
              class="mx-auto"
              type="text"
            ></v-skeleton-loader>
            <v-select
              :dark="$store.getters.getColorPalette().isDark"
              :color="$store.getters.getColorPalette().inputtextColor"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
              v-if="!loading"
              v-model="widgetForm.meta.logbook_id"
              :items="logbookOptions"
              :label="$store.getters.getTextMap().log_book"
              dense
              outlined
              item-text="label"
              item-value="value"
            ></v-select>
          </v-col>
          <v-col align-self="center">
            <v-skeleton-loader
              v-if="loading"
              class="mx-auto"
              type="text"
            ></v-skeleton-loader>
            <v-select
              :dark="$store.getters.getColorPalette().isDark"
              :color="$store.getters.getColorPalette().inputtextColor"
              :menu-props="{ dark: $store.getters.getColorPalette().isDark }"
              v-if="!loading"
              v-model="widgetForm.meta.kpi"
              :items="kpiOptions"
              :label="$store.getters.getTextMap().kpis"
              dense
              outlined
              item-text="label"
              item-value="value"
            ></v-select>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer />
          <v-col cols="auto" class="d-flex mt-2" align="right">
            <v-btn
              :dark="$store.getters.getColorPalette().isDark"
              :color="$store.getters.getColorPalette().submitbtnColor"
              small
              filled
              @click="onSubmit"
              >{{ $store.getters.getTextMap().submit }}</v-btn
            >
            <v-btn
              class="mx-1"
              :dark="$store.getters.getColorPalette().isDark"
              :color="$store.getters.getColorPalette().cancelbtnColor"
              small
              @click="onClose"
              >{{ $store.getters.getTextMap().cancel }}</v-btn
            >
          </v-col>
        </v-row>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
import FormRules from "@/utillities/FormRules";
import InfoAlert from "@/components/InfoAlert";
import axios from "axios";
export default {
  name: "AddManufacturingLogbookKpiBartrendWidget",
  props: ["widget", "seq", "disableTimeframe"],
  components: {
    InfoAlert,
  },
  data() {
    return {
      showDismissibleAlert: false,
      info: "",
      loading: false,
      api: "createWidgetForView",
      edit: false,
      widgetValid: false,
      logbookOptions: [],
      kpiOptions: [],
      widthOptions: [
        { label: "Full screen", value: 12 },
        { label: "Half screen", value: 6 },
        { label: "1/3 screen", value: 4 },
        { label: "Quarter screen", value: 3 },
        { label: "3/4 screen", value: 9 },
        { label: "Auto", value: null },
      ],
      heightOptions: [
        { label: "Fixed", value: "fixed" },
        { label: "Flex", value: "flex" },
      ],
      tdOptions: [
        { label: "last 7 days", value: "7" },
        { label: "last 30 days", value: "30" },
        { label: "last 60 days", value: "60" },
        { label: "last 90 days", value: "90" },
        { label: "last 180 days", value: "180" },
        { label: "last 365 days", value: "365" },
        { label: "MTD", value: "mtd" },
        { label: "YTD", value: "ytd" },
      ],
      aggregationOptions: [
        { label: "Summation", value: "sum" },
        { label: "Average", value: "avg" },
      ],
      graphTypeOptions: [
        { label: "Bar", value: 2 },
        { label: "Line", value: 1 },
      ],
      widgetForm: {
        height: "flex",
        width: 12,
        meta: {
          logbook_id: "",
          kpi: "",
          aggregation: "sum",
          timeFrame: "7",
          graph_type: 2,
          consolidate_data: false,
          xaxisLabel: null,
          yaxisLabel: null,
        },
      },
      rules: FormRules.rules,
    };
  },
  mounted() {
    this.init();
    this.getManufacturingLogbookOptions();
  },
  methods: {
    init() {
      if (this.widget && this.widget.widget_id && this.widget.view_id) {
        this.edit = true;
        this.widgetForm = Object.assign({}, this.widget);
        this.api = "updateWidget";
        if (!this.widgetForm.meta) {
          this.widgetForm.meta = {
            logbook_id: "",
            kpi: "",
            aggregation: "sum",
            timeFrame: "7",
            graph_type: 2,
            consolidate_data: false,
            xaxisLabel: null,
            yaxisLabel: null,
          };
        }
      } else {
        if (this.widget.view_id) {
          this.api = "createWidgetForView";
          this.widgetForm = Object.assign({}, this.widget);
          this.widgetForm.meta = {
            logbook_id: "",
            kpi: "",
            aggregation: "sum",
            timeFrame: "7",
            graph_type: 2,
            consolidate_data: false,
            xaxisLabel: null,
            yaxisLabel: null,
          };
          this.widgetForm.seq = this.seq ? this.seq : 0;
        }
      }
    },
    getManufacturingLogbookOptions() {
      let op = [];
      this.loading = true;
      axios
        .get(this.$store.state.api + "manufacturing_logbooks", {
          headers: { Authorization: "Bearer " + this.$store.state.jwt },
        })
        .then((response) => {
          if (response.data.status == "success") {
            for (let i of response.data.data) {
              op.push({ label: i.name, value: i.logbook_id });
            }
          } else {
            this.info = response.data.msg;
            this.showDismissibleAlert = true;
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.info = err;
          this.showDismissibleAlert = true;
        });
      this.logbookOptions = op;
    },
    getManufacturingLogbookKPIOptions() {
      let op = [];
      let payload = {
        logbook_id: this.widgetForm.meta.logbook_id,
      };
      this.loading = true;
      axios
        .post(
          this.$store.state.api + "getManufacturingLogbookKPIsByLogbookid",
          payload,
          {
            headers: { Authorization: "Bearer " + this.$store.state.jwt },
          }
        )
        .then((response) => {
          if (response.data.status == "success") {
            for (let i of response.data.data) {
              op.push({ label: i.kpi, value: i.kpi });
            }
          } else {
            this.info = response.data.msg;
            this.showDismissibleAlert = true;
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.info = err;
          this.showDismissibleAlert = true;
        });
      this.kpiOptions = op;
    },
    onSubmit() {
      this.$refs.widgetForm.validate();
      if (this.widgetValid) {
        this.loading = true;
        axios
          .post(this.$store.state.api + this.api, this.widgetForm, {
            headers: { Authorization: "Bearer " + this.$store.state.jwt },
          })
          .then((response) => {
            if (response.data.status === "success") {
              this.loading = false;
              this.$emit("success");
              this.$emit("close");
            } else {
              this.info = response.data.msg;
              this.showDismissibleAlert = true;
              this.loading = false;
            }
          })
          .catch((err) => {
            console.log(err);
            this.info = err;
            this.showDismissibleAlert = true;
            this.loading = false;
          });
      }
    },
    onClose() {
      this.$emit("close");
    },
  },
  watch: {
    "widgetForm.meta.logbook_id"() {
      this.getManufacturingLogbookKPIOptions();
    },
    widget() {
      this.init();
    },
  },
};
</script>
